const getters = {
  userInfo: state => state.userInfo,
  userRoleInfo: state => state.userRoleInfo,
  currentPage:state => state.currentPage,
  pageCount:state => state.pageCount
};
export default getters;